var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { ThemeFamilies } from '../../../theme/families';
import { ErrorVariant } from './index';
import getThemeTypography, { Typographies } from '../../../utils/getThemeTypography';
export default function FieldMessage(_a) {
    var name = _a.name, description = _a.description, error = _a.error, errorVariant = _a.errorVariant;
    if (!description && !error) {
        return null;
    }
    return (_jsxs(Container, __assign({ className: name + "-field-message-container" }, { children: [description && _jsx(Message, { children: description }, void 0),
            error && errorVariant === ErrorVariant.Bottom && (_jsx(Error, __assign({ themeFamily: ThemeFamilies.ERROR, "data-testid": name && name + "-error-label" }, { children: error }), void 0))] }), void 0));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding: 0 15px;\n  margin-top: 4px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 0 15px;\n  margin-top: 4px;\n"])));
var MessageTypography = styled.p(getThemeTypography(Typographies.BODY2));
var Message = styled(MessageTypography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0;\n  color: ", ";\n"], ["\n  margin: 0;\n  color: ",
    ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.surface1;
});
var Error = styled(Message)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme, themeFamily = _a.themeFamily;
    var main = theme.families.textField[themeFamily].main;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), main);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
